import { render, staticRenderFns } from "./BurgerKingAnimation.vue?vue&type=template&id=04fc8eb0"
import script from "./BurgerKingAnimation.vue?vue&type=script&lang=js"
export * from "./BurgerKingAnimation.vue?vue&type=script&lang=js"
import style0 from "./BurgerKingAnimation.vue?vue&type=style&index=0&id=04fc8eb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports